import { render } from "./memberCenter.vue?vue&type=template&id=2520e1c7&scoped=true"
import script from "./memberCenter.vue?vue&type=script&lang=js"
export * from "./memberCenter.vue?vue&type=script&lang=js"

import "./memberCenter.vue?vue&type=style&index=0&id=2520e1c7&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2520e1c7"]])

export default __exports__